import { render } from "./SystemIdentity.vue?vue&type=template&id=514a1b8c&scoped=true"
import script from "./SystemIdentity.vue?vue&type=script&lang=js"
export * from "./SystemIdentity.vue?vue&type=script&lang=js"

import "./SystemIdentity.vue?vue&type=style&index=0&id=514a1b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514a1b8c"]])

export default __exports__